/**
 * #580 (owner decision d-20260928-12) — the signed-in member's notification switches, read from
 * E24 `GET` and saved through E25 `PUT /api/notification-prefs`.
 *
 * Both endpoints answer for the signed-in ACCOUNT, never a user id in the path, and both answer with
 * the member's whole list (`{ prefs: [{ category, enabled, overridden, eligible }] }`). The server
 * decides who may switch what; this module never does. It reports what the server answered.
 */
import { api } from './client.js';
import { ensureCsrfToken } from './session.js';

export const NOTIFICATION_PREFS_PATH = '/api/notification-prefs';

/** @throws when the server cannot be reached, refuses, or answers without a list. */
export async function fetchNotificationPrefs() {
  const answer = await api.get(NOTIFICATION_PREFS_PATH);
  if (!answer || !Array.isArray(answer.prefs)) throw new Error('The server answered without notification preferences');
  return answer;
}

/**
 * Save ONE category. Only the switch that changed is sent, so a save never re-asserts another.
 * Returns the server's answer as it came; the caller reads the confirmed value out of it.
 */
export async function saveNotificationPref(category, enabled) {
  await ensureCsrfToken();
  return api.put(NOTIFICATION_PREFS_PATH, { prefs: [{ category, enabled }] });
}
